import { render, staticRenderFns } from "./primaryTabs.vue?vue&type=template&id=568b2240&scoped=true"
import script from "./primaryTabs.vue?vue&type=script&lang=js"
export * from "./primaryTabs.vue?vue&type=script&lang=js"
import style0 from "./primaryTabs.vue?vue&type=style&index=0&id=568b2240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b2240",
  null
  
)

export default component.exports